// extracted by mini-css-extract-plugin
module.exports = {"noResults":"ev_ew","container":"ev_e","recommendEvent":"ev_ex"};